import Box from "@mui/material/Box";
import { useEditContext, Loading } from "react-admin";
import ClientFamily from "./ClientFamily";
import ClientRevisions from "./ClientRevisions";
import ClientDuplicates from "./ClientDuplicates";

const ClientEditAside = () => {
	const { record, isLoading } = useEditContext();

	if (isLoading || !record)
		return (
			<Box>
				<Loading />
			</Box>
		);

	return (
		<Box>
			<ClientFamily />
			<ClientRevisions />
			<ClientDuplicates />
		</Box>
	);
};

export default ClientEditAside;
